import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner, Modal, Button } from "react-bootstrap";
import { getResults } from "../../../store/actions/studentAction/studentAuth";
import { useParams } from "react-router-dom";
import { courseType, examType } from "../../../utils/constant";

const Result = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const { studentAuth } = useSelector((state) => state.student);
  const { profile } = studentAuth;
  const dispatch = useDispatch();
  const { id } = useParams();
  const fetchdata = async () => {
    const response = await dispatch(
      getResults(id ? id : studentAuth.profile.id)
    );
    if (response) {
      setData(response);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    setLoading(true);
    fetchdata();
  }, []);
  return (
    <div>
      <div className="mid-content-box">
        <div className="Widthdata">
          <div className="Applicationdata s">
            <div className="row ">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th> Roll Number </th>
                      <th> Course </th>
                      <th> Enroll. Fee </th>
                      <th> Exam Fee </th>
                      <th> Result</th>

                      <th>Mark sheet </th>
                      <th>Certificate </th>
                      <th> Status</th>
                      <th>Membership</th>
                    </tr>
                    {loading ? (
                      <tr>
                        <td colSpan={10}>
                          <div className="text-center">
                            <Spinner animation="border" role="status" size="lg">
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </Spinner>
                          </div>
                        </td>
                      </tr>
                    ) : data ? (
                      <>
                      <tr>
                        <td>{data.studentData?.name}</td>
                        <td>{data.studentData?.roll_number}</td>
                        <td>{data.studentData?.course.name}</td>
                        {(() => {
                          const course = data.studentData?.course || {};
                          const fees = data.studentData?.fees || [];
                          const courseWise =
                            course.exam_type === "course_wise" ||
                            course.exam_type === "subject_wise";

                          // The registration fee is paid once. It counts as
                          // received when the flag is set OR a registration
                          // fee has been recorded - a fee taken at the center
                          // sets the flag but the student was still shown
                          // Pending because only the rows were being read.
                          const regFee = fees.find(
                            (f) => Number(f.registration_fee) > 0
                          );
                          const registrationPaid =
                            data.studentData?.fee_status == 1 || !!regFee;

                          // Semester and yearly courses pay again each term.
                          const termFees = fees.filter(
                            (f) => Number(f.exam_fee) > 0
                          );
                          const termWord =
                            course.course_type === courseType.semester
                              ? "Semester"
                              : "Year";

                          return (
                            <>
                              <td>
                                {registrationPaid ? (
                                  <>
                                    Paid
                                    {regFee?.link && (
                                      <>
                                        {" "}
                                        <a
                                          className="btn btn-success btn-sm"
                                          href={regFee.link}
                                          target="_blank"
                                          rel="noreferrer"
                                        >
                                          Receipt
                                        </a>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  "Pending"
                                )}
                              </td>
                              <td>
                                {courseWise ? (
                                  // Paid once at registration - there is no
                                  // separate examination fee for these courses.
                                  <span className="text-muted">Not applicable</span>
                                ) : termFees.length > 0 ? (
                                  termFees.map((fee) => (
                                    <a
                                      key={fee.id}
                                      className="btn btn-success btn-sm mr-1"
                                      href={fee.link}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {termWord} {fee.semester}
                                    </a>
                                  ))
                                ) : (
                                  "Pending"
                                )}
                              </td>
                            </>
                          );
                        })()}

                        {data.studentData?.course.exam_type == "course_wise" ? (
                          <>
                            <td>
                              {data.result ? (
                                <a href={data.result} target="_blank">
                                  View
                                </a>
                              ) : (
                                "Pending"
                              )}
                            </td>
                            <td>
                              {data.Marksheet ? (
                                <a href={data.Marksheet} target="_blank">
                                  View
                                </a>
                              ) : (
                                "Pending"
                              )}
                            </td>
                            <td>
                              {data.CertificateData ? (
                                <a href={data.CertificateData} target="_blank">
                                  View
                                </a>
                              ) : (
                                "Pending"
                              )}
                            </td>
                          </>
                        ) : (
                          <>
                            <td>
                              {data.result ? (
                                <a href={data.result} target="_blank">
                                  View
                                </a>
                              ) : (
                                "Pending"
                              )}
                            </td>
                            <td>
                              <table border="1">
                                {data.Marksheet
                                  ? data.Marksheet.map((e, index) => (
                                      <tr>
                                        <td>
                                          {data.studentData?.course
                                            .course_type == "2"
                                            ? `Sem ${index + 1} `
                                            : `Year ${index + 1} `}
                                          <a
                                            href={Object.values(e)[0]}
                                            target="_blank"
                                          >
                                            View
                                          </a>
                                        </td>
                                      </tr>
                                    ))
                                  : "Pending"}
                              </table>
                            </td>
                            {/* the certificate cell was missing here, so every
                                semester row sat one column left of its header */}
                            <td>
                              {data.CertificateData ? (
                                <a href={data.CertificateData} target="_blank">
                                  View
                                </a>
                              ) : (
                                "Pending"
                              )}
                            </td>
                          </>
                        )}
                        <td>
                          {data.CertificateData ? "Completed" : "Pending"}
                        </td>
                        {/* Membership column - only for courses the council
                            approved for membership. Applied & approved -> member
                            (dashboard) certificate; pending -> badge; not applied
                            -> Apply button; not a membership course -> "-". */}
                        <td>
                          {Number(data.studentData?.membership_allowed) === 1 ? (
                            data.studentData?.membership_status === "Approved" ? (
                              <a
                                className="btn btn-info btn-sm"
                                href={`https://nsvec.com/api/public/Individual/MemberData/${encodeURIComponent(
                                  data.studentData?.membership_reg_no ||
                                    data.studentData?.roll_number
                                )}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Member Certificate
                              </a>
                            ) : data.studentData?.membership_status ===
                              "Pending" ? (
                              <span className="badge bg-warning">
                                Membership Pending
                              </span>
                            ) : (
                              <a
                                className="btn btn-success btn-sm"
                                href="/member/register"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Apply Membership
                              </a>
                            )
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                      </>
                    ) : (
                      <tr>
                        <td colSpan={10}>No Record Found</td>
                      </tr>
                    )}
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Result;
